import { BulkActionsApiContext, BulkActionsDataContext } from "components/BulkActions/Context";
import { type BulkActionItemResults } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsCloseMethod,
  BulkActionsVariant,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import { useDrawerContext } from "ds/components/Drawer/DrawerContext";
import DrawerFooter from "ds/components/Drawer/Footer";
import TabPanel from "ds/components/TabPanel";
import { AnalyticsPage } from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";

import { TABS_ORDER } from "../constants";
import { BulkActionsDrawerResultsStepFooterContinueWith } from "./ContinueWith";

type BulkActionsDrawerResultsStepTabsFooterProps = {
  currentTab: BulkActionResultTabs;
  bulkActionItemResults: BulkActionItemResults;
  onContinueEnabled?: boolean;
  stopExecution: () => void;
  analyticsPage: AnalyticsPage;
  rerunWithFailedOnly?: boolean;
};

const BulkActionsDrawerResultsStepFooter = ({
  currentTab,
  bulkActionItemResults,
  stopExecution,
  onContinueEnabled,
  analyticsPage,
  rerunWithFailedOnly,
}: BulkActionsDrawerResultsStepTabsFooterProps) => {
  const { isExecutingBulkActions } = useTypedContext(BulkActionsDataContext);
  const { closeBulkActions } = useTypedContext(BulkActionsApiContext);
  const drawerId = useDrawerContext();

  return (
    <DrawerFooter>
      {TABS_ORDER.map((tab) => (
        <TabPanel
          key={tab}
          id={drawerId ? `${drawerId}-${tab}-footer` : `${tab}-footer`}
          isActive={currentTab === tab}
          aria-labelledby={drawerId ? `tab-${drawerId}-${tab}` : `tab-${tab}`}
        >
          <Box direction="row" gap="medium">
            <Button
              size="medium"
              variant="secondary"
              onPress={() =>
                closeBulkActions(
                  BulkActionsVariant.Drawer,
                  BulkActionsCloseMethod.ResultsCloseButton
                )
              }
            >
              Close
            </Button>
            {isExecutingBulkActions && (
              <Button
                size="medium"
                variant="secondary"
                disabled={!isExecutingBulkActions}
                onPress={stopExecution}
              >
                Stop all
              </Button>
            )}
            {!isExecutingBulkActions && onContinueEnabled && (
              <BulkActionsDrawerResultsStepFooterContinueWith
                bulkActionItemResults={bulkActionItemResults}
                rerunWithFailedOnly={rerunWithFailedOnly}
                analyticsPage={analyticsPage}
              />
            )}
          </Box>
        </TabPanel>
      ))}
    </DrawerFooter>
  );
};

export default BulkActionsDrawerResultsStepFooter;
